import infoIcon from "../assets/info.svg";
import React from "react";

const HelperIcon = ({ title }) => {
  return <img src={infoIcon} className={"icon-info"} alt={""} title={title} />;
};

export { HelperIcon };
